import { Component, OnInit } from '@angular/core';
import { RegulationsService } from '../../services/regulations-service';
import { Router } from '@angular/router';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { RegulationDetailsComponent } from '../regulation-details/regulation-details.component';
import { AddRegulationComponent } from '../add-regulation/add-regulation.component';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-get-regulations',
  templateUrl: './get-regulations.component.html',
  styleUrls: ['./get-regulations.component.scss'],
})
export class GetRegulationsComponent extends BaseComponent implements OnInit {

  form:FormGroup

  constructor(
    public service: RegulationsService,
    route: Router,
    private diag: NbDialogService,
    private fb:FormBuilder,
    private toast: NbToastrService
  ) {
    super(route, service, null);
  }

  ngOnInit() {
    this.initForm();
    this.loadEntities();
  }
initForm(){
  this.form = this.fb.group({
    nameAR: [''],
  });
}


clearFilter(){
  if( this.form.value.nameAR == '' ){
    return
  }
  else {
    this.loadEntitiesWithFilter('')
     this.form.controls['nameAR'].setValue('');
  }
  
}

handleSearch(){


  if( this.form.value.nameAR == '' ){
    this.toast.danger('برجاءاختيار الاسم لاتمام عملية البحث', 'رساله تحذيرية'); 
    return
  }

  else {
  this.loadEntitiesWithFilter(`nameAR:${this.form.value.nameAR.trim()}`)  }
}


  addNew() {
    this.diag
      .open(AddRegulationComponent, {
        dialogClass: 'custom-dialog-height',
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }

  delete(id) {
    this.service.delete(id).subscribe((res) => {
      this.loadEntities();
      this.toast.show('تم الحذف بنجاح', '', { status: 'success', duration: 3000 });
    });
  }

  detail(model) {
    this.diag.open(RegulationDetailsComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        model: model,
      },
    });
  }

  update(model) {
    const copymodel = {...model}
    this.diag
      .open(AddRegulationComponent, {
        dialogClass: 'custom-dialog-height',
        context: {
          model: copymodel,
          isEdit: true,
        },
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }
}
